export {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  tableCellSchema,
  tableHeaderCellSchema,
  tableRowSchema,
  tableHeaderSchema,
  tableBodySchema,
  tableSchema,
} from './table';
